import { tokens } from "@blurb/codex-react";
import { Flex } from "@rpi/openapi-core";
import React from "react";

interface FieldFrameProps {
  children: React.ReactNode;
  "data-testid"?: string;
}

/** Bordered inner container that frames the data rows in the Account and Organization cards. */
export const FieldFrame: React.FC<FieldFrameProps> = ({ children, ...rest }) => (
  <Flex.Column
    {...rest}
    gap={24}
    p={16}
    fullWidth
    sx={{
      border: `1px solid ${tokens.color.semantic.border.faint}`,
      borderRadius: tokens.radius.sm,
    }}
  >
    {children}
  </Flex.Column>
);
